import readCookie from "./readCookie";
import createCookie from "./createCookie";
import getQueryParams from "./getQueryParams";
/* eslint-disable */
export default function getGuid() {
  let guid = null;

  const p = getQueryParams();
  if (typeof p.guid !== "undefined") {
    const { guid } = p;
    createCookie("guid", guid, 365);
  } else {
    guid = readCookie("guid");
  }

  return guid;
}
